import { ArrowRight, ShieldCheck } from 'lucide-react';
import Container from '../ui/Container';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';
import Icon from '../ui/Icon';
import { certifications } from '../../data/certifications';
import { deliverableDocs } from '../../data/process';

/** Certifications + the document set a client receives. */
export default function ComplianceStrip() {
  return (
    <section className="section bg-surface" id="compliance">
      <Container>
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <Reveal direction="right">
            <span className="eyebrow">
              <ShieldCheck className="h-3.5 w-3.5" />
              Compliance & certifications
            </span>
            <h2 className="mt-5 text-3xl font-bold leading-tight tracking-tight sm:text-4xl">
              Licensed, audited and documented — every single time
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-500">
              We hold the authorisations that let us issue statutory documentation in our own name.
              Nothing is subcontracted, so there is never a gap in your audit trail.
            </p>

            <div className="mt-8 grid gap-3 sm:grid-cols-2">
              {certifications.slice(0, 4).map((cert) => (
                <div
                  key={cert.id}
                  className="rounded-xl border border-ink-100 bg-white p-4 transition-all duration-300 hover:border-brand-200 hover:shadow-soft"
                >
                  <p className="font-display text-sm font-bold text-brand-700">{cert.code}</p>
                  <p className="mt-1 text-xs leading-snug text-ink-600">{cert.title}</p>
                  <p className="mt-2 text-[0.68rem] text-ink-400">Valid till {cert.validTill}</p>
                </div>
              ))}
            </div>

            <Button to="/compliance" variant="outline" className="mt-8" size="lg">
              View compliance details
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Reveal>

          <Reveal direction="left" delay={0.1}>
            <div className="rounded-xl2 border border-ink-100 bg-white p-7 shadow-soft sm:p-8">
              <h3 className="font-display text-lg font-semibold text-ink-900">
                What lands in your inbox
              </h3>
              <p className="mt-2 text-sm text-ink-500">
                The complete document set issued with every engagement — no add-on charges.
              </p>

              <ul className="mt-7 grid gap-x-6 gap-y-5 sm:grid-cols-2">
                {deliverableDocs.map((doc) => (
                  <li key={doc.name} className="group flex gap-3.5">
                    <span className="grid h-9 w-9 flex-none place-items-center rounded-lg bg-brand-50 text-brand-700 transition-colors duration-300 group-hover:bg-brand-600 group-hover:text-white">
                      <Icon name={doc.icon} className="h-4 w-4" />
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-ink-900">{doc.name}</p>
                      <p className="mt-0.5 text-xs leading-snug text-ink-500">{doc.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
